import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';

export const GET_CONSULTANT_NUMBERS = gql`
  query getConsultantNumbers($companyId: ObjectId!, $queryOptions: QueryOptionsInput) {
    getConsultantNumbers(companyId: $companyId, queryOptions: $queryOptions) {
      collection {
        _id
        details
        consultantNumber
        createdBy
        datevClientNumbers {
          _id
          status
          details
          datevNumber
          consultantNumberId
        }
      }
      totalCount
    }
  }
`;

export const useGetConsultantNumbers = (companyId?: string) => {
  const [currentPage, setPage] = useState(1);
  const [currentNameSort, setNameSort] = useState<{ field: string; sortBy: number }[]>([
    { field: 'consultantNumber', sortBy: 1 },
  ]);
  const pageSize = 12;
  const { data } = useQuery(GET_CONSULTANT_NUMBERS, {
    variables: {
      companyId,
      queryOptions: {
        limit: pageSize,
        skip: pageSize * currentPage - pageSize,
        sort: currentNameSort,
      },
    },
    skip: !companyId,
    fetchPolicy: 'network-only',
  });

  const getConsultantNumbers = data?.getConsultantNumbers || {};

  return {
    collection: getConsultantNumbers?.collection || [],
    paginationConfig: {
      total: getConsultantNumbers?.totalCount || 0,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
    onTableChange: (a: any, b: any, { order }: any) => {
      if (order) {
        const sortBy = order === 'ascend' ? 1 : -1;

        setNameSort([{ field: 'consultantNumber', sortBy }]);
      }
    },
  };
};
